import { useImperativeHandle, forwardRef, useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import uuid from 'react-uuid';
import { Modal } from 'bootstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Loader from '../../../components/ui/Loader/Loader';
import TapSelect from '../../../components/ui/TapSelect';
import TapIcon from '../../../services/TapIcon';
import HttpAPICall from '../../../services/HttpAPICall';
import { IAM_API_BASE_URL_2, IAM_SUBASSEMBLY_URL, INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { toast } from 'react-toastify';

const AddNewTermConditionModal = forwardRef((props, ref) => {

    const initAddTermForm = {
        name                :   '',
        text                :   '',
        tag_ids             :   []
    };
    const [modalId, setModalId]                 =   useState(uuid());
    const [tncModalLoader, setTncModalLoader]   =   useState(false);
    const [addTermFormSubmitting, setAddTermFormSubmitting] =   useState(false);
    const [addTermForm, setAddTermForm]         =   useState({ ...initAddTermForm });
    const [editTNCIndex, setEditTNCIndex]       =   useState(null);


    const TagUrlList                    =   IAM_SUBASSEMBLY_URL + '/tag/list';
    const termConditonAddUrl            =   INVENTORY_API_BASE_URL_2 + '/term_condition/add';
    const modalElem                     =   useRef(null);
    const modal                         =   useRef(null);
    const access_token                  =   useSelector(state => state.auth.access_token);

    useImperativeHandle(ref, () => ({
        addTermConditionModalInit: (termData, index) => {

            if (termData) {
                setAddTermForm(pd => ({
                    ...pd,
                    name: termData.name || "",
                    text: termData.text || "",
                    tag_ids: termData.tags ? termData.tags.map(t => t.id) : []
                }));
                setEditTNCIndex(index);
            } else {
                setAddTermForm(initAddTermForm);
                setEditTNCIndex(null);
            }
            modalOpen()
        }
    }));
    const modalOpen         =   ()  =>  {
        if (modal.current) { modal.current.show(); }
    }

    const modalClose        =   ()  => {
        if (modal.current) { modal.current.hide(); }
    }

    useEffect(() => {
        addTermsModalInit()

        modalElem.current           =   document.getElementById(modalId);
        modal.current               =   new Modal(modalElem.current, { keyboard: false, backdrop: false });
        // Cleanup on unmount
        return () => {
            if (modal.current) {
                modal.current.dispose();
            }
        };
    }, []);

    const handleInputChange         = (e) => {
        setAddTermForm(pd => ({
            ...pd,
            [e.target.name]: e.target.value
        }));
    };


    const tapSelectChange           = (selectedOption, formName, fieldName) => {
        setAddTermForm((prev) => ({
            ...prev,
            [fieldName]: selectedOption.map(o => o.value),
        }));
    };

    const addTermsModalInit         = () => {
        if (props.tncTags.length <= 0) {
            setTncModalLoader(true)
            HttpAPICall.withAthorization('GET', TagUrlList, access_token, { type: 'sales_invoice' }, {}, (resp) => {
                props.setTncTags(resp.data && resp.data.length > 0 ? resp.data.map(val => ({ label: val.name, value: val.id })) : [])
            }).then(() => {
                setTncModalLoader(false)
            });
        }
    }

    const submitAddTermForm         = (e) => {
        e.preventDefault()
        let frmData = { ...addTermForm };

        let index                   =   editTNCIndex;
        if (index !== null) {
            let tnc = props.formData.tnc;
            let updatedTnc = {
                ...tnc[index],
                name: frmData.name,
                tags: props.allTNCTags.filter(t => frmData.tag_ids.includes(t.id)),
                tag_ids: frmData.tag_ids,
                text: frmData.text
            };
            tnc[index] = updatedTnc;

            let termCoditions = props.termCoditions;
            if (termCoditions.find(t => t.name == updatedTnc.name)) {
                termCoditions = [...termCoditions.filter(t => t.name != updatedTnc.name), updatedTnc]
            } else {
                termCoditions = [...termCoditions, { ...updatedTnc, id: null }]
            }
            props.setTermCoditions(termCoditions)
            props.setFormData({ ...props.formData, tnc })
            setEditTNCIndex(null)
            modalClose()
        } else {
            setAddTermFormSubmitting(true)
            HttpAPICall.withAthorization('POST', termConditonAddUrl, access_token, {}, { ...frmData, key: "sales_invoice" }, (response) => {
                props.getTermListing();
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                modalClose()
            }).then(() => setAddTermFormSubmitting(false))
        }
    }

    return <>
        <div className="modal fade" id={modalId} tabIndex="-1" ref={modalElem}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Terms & Condition</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    { tncModalLoader 
                      ? <Loader />
                      : <form onSubmit={submitAddTermForm} id="addTermsForm" method="post" encType="multipart/form-data">
                            <div className="modal-body">
                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label htmlFor="transaction Type" className="form-label ">Name</label>
                                    </div>
                                    <div className="col-sm-9">
                                        <input
                                            name="name"
                                            type="text"
                                            className="form-control"
                                            autoComplete="off"
                                            onChange={(e) => handleInputChange(e)}
                                            value={addTermForm.name}
                                            placeholder="Please Enter Term Name"
                                        />
                                    </div>
                                </div>
                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label htmlFor="transaction Type" className="form-label ">Tag</label>
                                    </div>
                                    <div className="col-sm-9">
                                        <TapSelect
                                            options={props.tncTags}
                                            changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'addTermForm', 'tag_ids')}
                                            isSearchable={true}
                                            isClearable={true}
                                            value={props.tncTags.filter(s => addTermForm.tag_ids.includes(s.value))}
                                            isMulti={true}
                                            placeholder="Select Tag"
                                        />
                                    </div>
                                </div>
                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label htmlFor="transaction Type" className="form-label require ">Value</label>
                                    </div>
                                    <div className="col-sm-9">
                                        <CKEditor
                                            key={modalId}
                                            data={addTermForm.text}
                                            editor={ClassicEditor}
                                            onChange={(event, editor) => {
                                                setAddTermForm(pd => ({ ...pd, text: editor.getData() }))
                                            }}

                                            config={{
                                                placeholder: 'Please Enter Text',
                                                height: '300px',
                                                toolbar: [
                                                    'heading',
                                                    '|',
                                                    'bold',
                                                    'italic',
                                                    'link',
                                                    '|',
                                                    'bulletedList',
                                                    'numberedList',
                                                ]
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button"
                                    disabled={addTermFormSubmitting}
                                    className="btn btn-secondary mx-2"
                                    data-bs-dismiss="modal"
                                >Close</button>
                                <button type="submit" disabled={addTermFormSubmitting} className="btn btn-primary">
                                    Submit {addTermFormSubmitting && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}
                                </button>
                            </div>
                        </form>
                    }
                </div>
            </div>
        </div>
    </>
});

export default AddNewTermConditionModal;